export enum UrlParameter {
  DashboardId = 'dashboard',
  SubjectAreaId = 'subject-area',
  MainDashboard = 'mainDashboard',
  DetailDashboard = 'detailDashboard',
  KpiId = 'kpi',
  MyInsights = 'my-insights',
  KpiHub = 'kpi-hub',
  LandingId = 'landing',
}
